import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import { TFormState } from '../../../../models/forms.model';
import { STEPS_STYLING_MAP } from '../../models/contract-styling-consts';
import { ContractMemberModel } from '../../../../models/contract.model';
import { MemberModel } from '../../../../models/user.model';
import { AlertService } from '../../../../services/notify/alert.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ContractDataService } from '../../services/contract-data.service';
import { ContractFormService } from '../../services/contract-form.service';

@Component({
    selector: 'app-contract-party-select',
    templateUrl: './contract-party-select.component.html',
    styleUrl: './contract-party-select.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush,
 
})
export class AppContractPartySelectComponent {
  @Input() currentMember!: MemberModel
  @Input() contractGuid: string = ''
  @Input() memberIsEmptyProject!: ContractMemberModel
    public stepsStylingMap = STEPS_STYLING_MAP
    public formState:TFormState = 'Default'
    constructor(
      private contractFormService:ContractFormService,
      private contractDataService:ContractDataService,
      private alertService:AlertService,
      private dialogRef:MatDialogRef<AppContractPartySelectComponent>
    ) { }
    onSetProject(projectGuid:string,  privateUser = false): void {
      this.formState = 'Submitting'
      let req = {
          member_guid: this.currentMember.guid,
          project_guid: projectGuid,
          private_member: privateUser,
          can_verify: this.memberIsEmptyProject.can_verify,
      };
      this.contractFormService.updateMemberToContract(this.contractGuid, req).subscribe({
          next: (msg:any) => {
              this.formState = 'Default'
              this.dialogRef.close()
              this.alertService.setAlert(msg.message, 'nd_color');
              console.log('onSetProject', )
              this.contractDataService.subContractReloadContract.next(true)
            },
            error: (error:any) => {
              this.dialogRef.close()
              this.formState = 'Default'
              this.alertService.setAlert(error.message, 'blue');
          },
      });
    }
}